module.exports = __webpack_public_path__ + "static/media/67.23d26bab.png";